module.exports = __webpack_public_path__ + "static/feature-hackathon-browser-5a044ca6908b6e62ac5be7426689d29b.svg";